import React from "react";
import {
  Typography,
  Tabel,
  DropDown,
  DropDownMenu,
  Modal,
  Badge,
  FilterWraper,
  ProgrssBox,
} from "../core";
import { reducer, initialState } from "../hooks/modalReducer";
import { Link } from "react-router-dom";
import { theme } from "../styles";
import { Menu, Row } from "antd";
import { useSelector } from "react-redux";
import { getCompanyDispatches } from "../helper/utils/api/dispatch";
import { getCompanyId } from "../helper/utils/companyId";
import Svg from "../assets/icons/icon";
const CHANGE_DATE_FORMAT = require("../helper/utils/datFormat");

const { textColor } = theme;
const columns = [
  {
    title: "SR #",
    dataIndex: "SNo",
    key: "S.No",
    render: (text, record, index) => <span>{index + 1}</span>,
    width: 150,
  },
  {
    title: "Date",
    dataIndex: "date_dispatch",
    key: "date_dispatch",
    render: (text, record, index) => {
      return (
        <span>
          {/* {record.invoice_date}
          <br /> */}
          {CHANGE_DATE_FORMAT.changeDateFormat(record.date_dispatch)}
        </span>
      );
    },
    width: 150,
  },
  {
    title: "Contract#",
    dataIndex: "contract_no",
    key: "contract_no",

    width: 150,
  },
  {
    title: "Buyer C.N",
    dataIndex: "buyer_company_name",
    key: "buyer_company_name",
    width: 150,
  },
  {
    title: "K Quantity",
    dataIndex: "k_qunatity",
    key: "k_qunatity",
    width: 150,
  },

  {
    title: "L Short/Rejection",
    dataIndex: "l_short/rejection",
    key: "l_short/rejection",
    render: (text, record, index) => (
      <span>
        {record.l_short}/{record.glr_received}
      </span>
    ),
    width: 150,
  },
  {
    title: "K Slip/P slip",
    dataIndex: "k_slip/p_slip",
    key: "k_slip/p_slip",
    width: 150,
    render: (text, record, index) => (
      <span>
        {record.k_patch_parchi_no}/{record.p_patch_parchi_no}
      </span>
    ),
  },

  {
    title: "Rej-Date",
    render: ({ date_cloth_return }) => (
      <span>
        {date_cloth_return
          ? CHANGE_DATE_FORMAT.changeDateFormat(date_cloth_return)
          : "----"}
      </span>
    ),
    key: "date_cloth_return",
    width: 150,
  },

  {
    title: "Net Pass",
    render: ({ net_pass }) => <span>{net_pass ? net_pass : "-----"}</span>,
    key: "net_pass",
    width: 150,
  },
  {
    title: "Invoice Status",
    dataIndex: "invoice_status",
    key: "invoice_status",
    render: (text) => (
      <Badge
        status={text ? "Generated" : "pending"}
        text={text ? "Generated" : "pending"}
      />
    ),
    width: 150,
  },
  {
    title: "Action",
    dataIndex: "action",
    width: 150,
    render: (text, record, index) => (
      <DropDown
        overlay={<MenuCompo index={index} record={record} />}
        record={record}
      />
    ),
  },
];

const typoProps = {
  as: "h3",
  weight: "bold",
  letterSpacing: "0.2px",
  color: textColor.primary,
  text: "Dispatch History",
};
const DispatchHistory = ({ theme, history, ...props }) => {
  const company_disptches_his = useSelector(
    (state) => state.dispatches?.company_disptches_his || []
  );
  const [records, setRecords] = React.useState([]);
  const [saleRecord, setSaleRecord] = React.useState([]);

  React.useEffect(() => {
    const load = async () => {
      const companyId = getCompanyId();
      if (!companyId) return;
      try {
        const { data } = await getCompanyDispatches(companyId);
        const list = data?.result || data || [];
        setRecords(Array.isArray(list) ? list : []);
      } catch (error) {
        console.log("company dispatch error", error);
        setRecords(company_disptches_his);
      }
    };
    load();
  }, [company_disptches_his]);

  React.useEffect(() => {
    setSaleRecord(records);
  }, [records]);
  const dateRange = (date, dateString) => {
    let min = dateString[0];
    let max = dateString[1];

    const filteredArray = records.filter((record) => {
      return record.date_dispatch >= min && record.date_dispatch <= max;
    });

    setSaleRecord(min && max ? filteredArray : records);
  };
  const changeInput = (e) => {
    let search_input = e.target.value;

    const filteredArrayByBuyer = records.filter((record) => {
      return (
        // record.k_patch_parchi_no.indexOf(search_input) > -1 ||
        // record.p_patch_parchi_no.indexOf(search_input) > -1 ||
        record.contract_no.indexOf(search_input) > -1 ||
        record.contract_type.indexOf(search_input) > -1
      );
    });
    setSaleRecord(filteredArrayByBuyer);
  };

  const total_dispatch = saleRecord
    ?.map((dispatches) => dispatches.k_qunatity)
    ?.reduce((acc, curr) => acc + curr, 0);
  console.log(
    "test total dispatches",
    total_dispatch,
    saleRecord?.map((dispatches) => dispatches.k_qunatity)
  );
  const total_rejection = saleRecord
    ?.map((dispatches) =>
      parseInt(dispatches.glr_received ? dispatches.glr_received : 0)
    )
    ?.reduce((acc, curr) => acc + curr, 0);
  const total_lshort = saleRecord
    ?.map((dispatches) => parseInt(dispatches.l_short ? dispatches.l_short : 0))
    ?.reduce((acc, curr) => acc + curr, 0);
  console.log("total_rejection", total_rejection);
  console.log("saleRecord", saleRecord);
  const total_accpet_cloth = saleRecord
    ?.map((dispatches) => dispatches.net_pass)
    ?.reduce((acc, curr) => acc + curr, 0);

  return (
    <>
      <Typography {...typoProps} />
      <Row type="flex" justify="space-around" gutter={[16, 16]}>
        <ProgrssBox
          svg={<Svg width={36.21} height={69.69} icon="yarnRecieved" />}
          status="primary"
          tittle="Total Cloth Dispatch"
          value={total_dispatch}
          Rs={false}
        />
        <ProgrssBox
          svg={<Svg width={59} height={39} icon="money" />}
          status="success"
          tittle="Total Rejection"
          value={total_rejection}
          Rs={false}
        />
        <ProgrssBox
          svg={<Svg width={59} height={39} icon="money" />}
          status="success"
          tittle="Total L Short"
          value={total_lshort}
          Rs={false}
        />

        <ProgrssBox
          svg={<Svg width={36.21} height={69.69} icon="yarnRecieved" />}
          status="warnning"
          tittle="Total Cloth Accept"
          value={total_accpet_cloth}
          Rs={false}
        />
      </Row>
      <FilterWraper
        rangeFilter={dateRange}
        inpputChange={changeInput}
        dropDown={false}
        range={true}
      ></FilterWraper>
      <Tabel
        // loading={!dispatchHistory[0] ? true : false}
        padding="0px 10px"
        pagination={false}
        columns={columns}
        data={saleRecord}
        rowKey={({ dispatch_id }) => dispatch_id}
      />
    </>
  );
};
const MenuCompo = (params) => {
  const { record } = params;
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const oK = () => {};
  function menuClickHandler({ key }) {
    return key === "delete"
      ? dispatch({
          type: "MODAL_VIEW",
          payload: { flag: true, modal_name: key },
        })
      : null;
  }
  return (
    <DropDownMenu onClick={menuClickHandler}>
      <Modal
        closable={true}
        visible={state.visible}
        // onCreate={onCreate}
        okText="Yes"
        onOk={oK}
        maxwidth="550px"
        cancelText="No"
        onCancel={(e) => {
          e.stopPropagation();
          dispatch({ type: "MODAL_VIEW", payload: false });
        }}
        tittle="Are You Sure you want to delete this record"
      ></Modal>
      {/* <Menu.Item key="view">
        <Link
          //  to={`/dispatch-inner`}
          to={{
            pathname: `/dispatch-inner`,
            state: {
              contract: record,
            },
          }}
        >
          view
        </Link>
      </Menu.Item> */}
      {/* <Menu.Item key="edit">Edit</Menu.Item> */}
      {record.cloth_return_id && record.invoice_status === false ? (
        <Menu.Item key="generate_invoice">
          <Link
            to={{
              pathname: `/generate-invoice/${record.contract_id}`,
              state: {
                contract: record,
              },
            }}
          >
            Generate Invoice
          </Link>
        </Menu.Item>
      ) : null}
      {record.cloth_return_id && record.invoice_status === true ? (
        <Menu.Item key="view_invoice">
          <Link to={`/print-invoice/${record.cloth_return_id}`}>
            Print Invoice
          </Link>
        </Menu.Item>
      ) : null}
    </DropDownMenu>
  );
};
export default DispatchHistory;
